import { IContactCompany } from '.';

export class NonLatestCompanyContact {
    EstablishmentContactOwned: string;
    EstablishmentThirdPartyContact: string;
    ImporterContact: string;
    RegistrantContact: string;
    USAgentContact: string;
    LabelerContact: string;
}
